import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <main class="flex min-h-[100dvh] min-h-screen w-full flex-col">
      <router-outlet />
    </main>
  `,
  styles: [],
})
export class AppComponent {
  /** Injected here only so the stored theme lands on <html> before anything renders. */
  private readonly theme = inject(ThemeService);
}
